package com.cybersoftsolution.cybersoftsolutionweb.components.dialogs

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.CloseButtonX
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyBorderRadius
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyButton
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyButtonNew
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyButtonType
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyButtonVariant
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyLoadingButton
import com.cybersoftsolution.cybersoftsolutionweb.components.capcha.SliderCaptchaBootstrap
import com.cybersoftsolution.cybersoftsolutionweb.components.checkbox.MyCheckBox
import com.cybersoftsolution.cybersoftsolutionweb.components.icons.MyIcons
import com.cybersoftsolution.cybersoftsolutionweb.components.text.MySpanText
import com.cybersoftsolution.cybersoftsolutionweb.components.textfield.InputTypeHTML
import com.cybersoftsolution.cybersoftsolutionweb.components.textfield.MyTextField
import com.cybersoftsolution.cybersoftsolutionweb.models.RestorePasswordParams
import com.cybersoftsolution.cybersoftsolutionweb.models.SignUpParams
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.cybersoftsolution.cybersoftsolutionweb.models.isValidInt
import com.cybersoftsolution.cybersoftsolutionweb.styles.ForgetPasswordButtonStyle
import com.cybersoftsolution.cybersoftsolutionweb.styles.GoogleButtonStyle
import com.cybersoftsolution.cybersoftsolutionweb.styles.LoginButtonStyle
import com.cybersoftsolution.cybersoftsolutionweb.styles.LoginStyle
import com.cybersoftsolution.cybersoftsolutionweb.styles.RegisterButtonStyle
import com.cybersoftsolution.cybersoftsolutionweb.use_cases.logInUseCase
import com.cybersoftsolution.cybersoftsolutionweb.use_cases.restorePasswordUseCase
import com.cybersoftsolution.cybersoftsolutionweb.use_cases.signUpUseCase
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.confirmNewPasswordTextFieldId
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.forgotPasswordButtonId
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.forgotPasswordText
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.googleAuthButtonId
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.loginButtonId
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.newPasswordTextFieldId
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.otpExpireInSecTextId
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.otpTextFieldId
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.passwordTextFieldId
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.registerButtonId
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.restorePasswordButtonId
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.returnButtonId
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources
import com.cybersoftsolution.cybersoftsolutionweb.utils.WebStorage.getRememberedLogin
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.scrollBehavior
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import kotlinx.browser.document
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.attributes.AutoComplete
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Form
import org.w3c.dom.HTMLButtonElement
import org.w3c.dom.HTMLInputElement

@Composable
inline fun SignInDialog(
    rootModifier: Modifier = Modifier,
    breakpoint: Breakpoint,
    scope: CoroutineScope,
    context: PageContext,
    userName: String,
    password: String,
    errorText: String = " ",
    captchaVerified: Boolean = false,
    otpCode: String?=null,
    newPassword: String?,
    confirmNewPassword: String?,
    crossinline setUsername: (String) -> Unit,
    crossinline setPassword: (String) -> Unit,
    crossinline setErrorText: (String) -> Unit,
    crossinline setOtpCode: (String?) -> Unit,
    crossinline setNewPassword: (String?) -> Unit,
    crossinline setConfirmNewPassword: (String?) -> Unit,
    crossinline onClose: () -> Unit,
    crossinline onGoogleAuthButtonClick: () -> Unit,
    crossinline onSignUpButtonClick: () -> Unit,
    crossinline onLoginSuccess:(successMessage:String?) -> Unit,
    crossinline onLoginFail:(errorMessage:String?) -> Unit,
    crossinline setCaptchaVerified: (Boolean) -> Unit,
    crossinline onRestorePasswordFail:(errorMessage:String?) -> Unit,
    crossinline onRestorePasswordSuccess:(successMessage:String?) -> Unit,
    crossinline onRestorePasswordComplete:() -> Unit,
) {  // Recibe una función para cerrar el modal

    var showForgotPasswordDialog by remember { mutableStateOf(false) }
    var restorePasswordButtonLoading by remember{ mutableStateOf(false) }
    var step by remember { mutableStateOf(1) }
    var otpExpireInSec:Int by remember { mutableStateOf(0) }


    LaunchedEffect(otpExpireInSec) {
        if (otpExpireInSec > 0) {
            delay(1000)
            otpExpireInSec -= 1
        }
    }

    LaunchedEffect(step) {
        if (step==-1) {

            delay(50)
            onRestorePasswordComplete()
            step = 1
        }
    }

    Box(
        contentAlignment = Alignment.TopStart,
        modifier = Modifier
            .thenIf(
                condition = breakpoint <= Breakpoint.SM,
                other = Modifier
                    .fillMaxWidth(95.percent)
//                    .height(95.percent)
            )
            .thenIf(
                condition = breakpoint == Breakpoint.MD,
                other = Modifier.width(500.px)
            )
            .thenIf(
                condition = breakpoint > Breakpoint.MD,
                other = Modifier.width(500.px)
            )
            .backgroundColor(Theme.LightGray.rgb)
            .borderRadius(15.px)
            .zIndex(80)
            .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
            .overflow(Overflow.Auto)
            .scrollBehavior(ScrollBehavior.Smooth)
            .then(rootModifier)


    ) {
        Column(
            verticalArrangement = Arrangement.Top,
            horizontalAlignment = Alignment.CenterHorizontally,
            modifier = Modifier
                .fillMaxSize()
                .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
        ) {
            Row(
                horizontalArrangement = Arrangement.End,
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(8.px)
            ) {
                CloseButtonX(
                    onClick = { onClose() }
                )
            }

            MyButtonNew(
                modifier = Modifier
                    .margin(top = 20.px)
                    .height(60.px)
                    .minHeight(60.px)
                    .width(90.percent),
                style = GoogleButtonStyle,
                id = googleAuthButtonId,
                borderRadius = 15.px,
                text = "Iniciar Sesión con Google",
//                faIconsClassName = Resources.FaIconsClassName.Register_User_ICO,
                image = {
                    Image(
                        modifier = Modifier
                            .fillMaxHeight(80.percent)
                            .backgroundColor(Theme.Withe.rgb)
                            .padding(5.px)
                            .borderRadius(15.px),
//                            .aspectRatio(1)
//                            .objectFit(ObjectFit.Cover),
                        src = Resources.Images.google,
                        alt = "Google Ico"
                    )
                },
                fontSize = 18,
                onClick = {
                    onGoogleAuthButtonClick()
                }
            )



            MySpanText(
                text = "Tambien puedes iniciar sesión con tu correo y tu contraseña",
                fontColor = Theme.HalfBlack.rgb,
                fontSize = 16,
                modifier = Modifier
                    .textAlign(TextAlign.Center)
                    .margin(top = 20.px)
            )

            if (showForgotPasswordDialog) {

                Column(
                    verticalArrangement = Arrangement.Top,
                    horizontalAlignment = Alignment.Start,
                    modifier = Modifier
                        .fillMaxWidth(90.percent)
                        .padding(20.px)
                        .margin(top = 20.px)
                        .backgroundColor(Theme.LightDarkGray.rgb)
                        .borderRadius(10.px)

                ){
                    Row(
                        horizontalArrangement = Arrangement.Start,
                        verticalAlignment = Alignment.CenterVertically,
                        modifier = Modifier
                            .fillMaxWidth()
                            .margin(bottom = 24.px)
                    ) {

                        MyButtonNew(
                            modifier = Modifier
                                .fillMaxHeight(),
                            style = LoginButtonStyle,
                            id = returnButtonId,
                            borderRadius = 5.px,
                            text = "Volver",
                            textColor = Colors.Black,
                            fontSize = 13,
                            faIconsClassName = Resources.FaIconsClassName.ArrowBack_ICO,
                            onClick = {
                                showForgotPasswordDialog = false
                            }
                        )
                    }

                    Form(
                        attrs = Modifier
                            .fillMaxWidth()
                            .toAttrs {  }
                    ) {
                        when (step) {
                            1 -> {
                                MyTextField(
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .height(50.px)
                                        .padding(leftRight = 10.px)
                                        .margin(bottom = 24.px)
                                        .fontSize(16.px)
                                        .borderRadius(10.px),
                                    text = userName,
                                    autoComplete = AutoComplete.email,
                                    style = LoginStyle,
                                    inputTypeHTML = InputTypeHTML.Text,
                                    placeholder = "Correo electrónico",
                                    onChange = {
                                        setUsername(it)
                                        setCaptchaVerified(false)
                                    },
                                    onEnter = {
                                        (document.getElementById(restorePasswordButtonId) as HTMLInputElement).focus();
                                    }

                                )

                                SliderCaptchaBootstrap(
                                    verified = captchaVerified,
                                    useErrorMessages = false,
                                    modifier = Modifier
                                        .margin(bottom = 24.px),
                                    onVerified = {
                                        setCaptchaVerified(true)
                                    },
                                    onError = { errorMessage ->
                                        setCaptchaVerified(false)
                                    }
                                )
                            }
                            2 -> {
                                Column(
                                    modifier = Modifier
                                        .margin(bottom = 24.px)
                                ) {
                                    MyTextField(
                                        id = otpTextFieldId,
                                        modifier = Modifier
                                            .fillMaxWidth()

                                            .height(50.px)
                                            .padding(leftRight = 10.px)
                                            .margin(bottom = 8.px)
                                            .fontSize(16.px)
                                            .borderRadius(10.px)
                                        ,
                                        maxLength = 6,
                                        text = otpCode,
                                        autoComplete = AutoComplete.oneTimeCode,
                                        style = LoginStyle,
                                        inputTypeHTML = InputTypeHTML.Text,
                                        //                        id = otpTextField,
                                        placeholder = "Codigo de Verificacion",
                                        onChange = {
                                            if (it.isValidInt()) setOtpCode(it) else setOtpCode(null)
                                        },
                                        onEnter = {
                                            (document.getElementById(restorePasswordButtonId) as HTMLInputElement).focus();
                                        }

                                    )

                                    SpanText(
                                        text = if (otpExpireInSec > 0) "El código de verificación expirará en $otpExpireInSec segundo/s" else "Tiempo agotado, solicite nuevamente",
                                        modifier = Modifier
                                            .fillMaxWidth()
                                            .textAlign(TextAlign.Justify)
                                            .id(otpExpireInSecTextId)
                                            .color(if (otpExpireInSec > 0) Theme.HalfBlack.rgb else Colors.Red)
                                            .fontWeight(FontWeight.Normal)
                                            .fontSize(FontSize.Small)

                                    )
                                }






                            }
                            3 -> {

                                MyTextField(
                                    id = newPasswordTextFieldId,
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .height(50.px)
                                        .padding(leftRight = 10.px)
                                        .margin(bottom = 24.px)
                                        .fontSize(16.px)
                                        .borderRadius(10.px),
                                    text = newPassword,
//                        autoComplete = AutoComplete.name,
                                    style = LoginStyle,
                                    inputTypeHTML = InputTypeHTML.Password,
                                    placeholder = "Establezca su contraseña",
                                    onChange = { setNewPassword(it) },
                                    onEnter = {
                                        (document.getElementById(confirmNewPasswordTextFieldId) as HTMLButtonElement).focus();
                                    }

                                )

                                MyTextField(
                                    id = confirmNewPasswordTextFieldId,
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .height(50.px)
                                        .padding(leftRight = 10.px)
                                        .margin(bottom = 24.px)
                                        .fontSize(16.px)
                                        .borderRadius(10.px),
                                    text = confirmNewPassword,
//                        autoComplete = AutoComplete.email,
                                    style = LoginStyle,
                                    inputTypeHTML = InputTypeHTML.Password,
                                    placeholder = "Confirme su contraseña",
                                    onChange = {
                                        setConfirmNewPassword(it)
                                    },
                                    onEnter = {
                                        (document.getElementById(registerButtonId) as HTMLButtonElement).focus();
                                    }

                                )

                            }
                            else -> {

                            }

                        }
                    }



                    MyLoadingButton(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(38.px),
                        id = restorePasswordButtonId,
                        text = when (step) {
                            1 -> if (captchaVerified) "Solicitar OTP" else "Resuelve el Captcha"
                            2 -> { if (otpExpireInSec > 0) {
                                "Continuar"
                            } else "Solicitar OTP"
                            }
                            else -> "Establecer Contraseña"
                        },
                        variant = when (step) {
                            1 -> MyButtonVariant.Warning
                            2 -> { if (otpExpireInSec > 0) {
                                MyButtonVariant.Warning
                            } else MyButtonVariant.Danger
                            }
                            else -> MyButtonVariant.Warning
                        },
                        borderRadius = MyBorderRadius(5.px),

                        disabled = !captchaVerified,
                        loading = restorePasswordButtonLoading,
                        icon = when (step) {
                            1 -> MyIcons.ENVELOPE_AT_FILL
                            2 -> { if (otpExpireInSec > 0) {
                                MyIcons.ENVELOPE_CHECK_FILL
                            } else MyIcons.ENVELOPE_AT_FILL
                            }
                            else -> MyIcons.KEY_FILL
                        },
                        onClick = {
                            if (!captchaVerified) {
                                return@MyLoadingButton
                            }

                            if (step==3) {
                                if (newPassword.isNullOrEmpty()) {
                                    onRestorePasswordFail("Por favor ingrese una contraseña")
                                    return@MyLoadingButton
                                }
                                if (confirmNewPassword.isNullOrEmpty()) {
                                    onRestorePasswordFail("Confirme su contraseña")
                                    return@MyLoadingButton
                                }
                                if (newPassword != confirmNewPassword) {
                                    onRestorePasswordFail("Las contraseñas no coinciden")
                                    return@MyLoadingButton
                                }
                            }

                            restorePasswordButtonLoading = true

                            scope.restorePasswordUseCase(
                                step = step,
                                setStep = {
                                    step = it
                                },
                                refreshOtpExpireInSec = { it ->
                                    otpExpireInSec = it?.toInt() ?: 0
                                },
                                restorePasswordParams = RestorePasswordParams(
                                    email = userName,
                                    otp = when (step) {
                                        1 -> otpCode?.toInt()
                                        2 -> { if (otpExpireInSec > 0) {
                                            otpCode?.toInt()
                                        } else null
                                        }
                                        else -> otpCode?.toInt()
                                    },
                                    password = when (step) {
                                        3 -> newPassword.orEmpty()
                                        else -> null
                                    },
                                ),
                                setErrorText = {
//                                setErrorText(it)
                                    onRestorePasswordFail(it)
                                },
                                onSuccess = { successMessage ->
                                    restorePasswordButtonLoading = false
                                    onRestorePasswordSuccess(successMessage)
                                },
                                onFail = { errorMessages ->
//                                console.log("Sign Error message: $errorMessages")
                                    restorePasswordButtonLoading = false
                                    onRestorePasswordFail(errorMessages)

                                }
                            )



                        }
                    )


                    SpanText(
                        text = errorText,
                        modifier = Modifier
                            .fillMaxWidth()
                            .textAlign(TextAlign.Center)
                            .id(errorText)
                            .color(Colors.Red)
                            .padding(leftRight = 24.px)
//                        .margin(bottom = 24.px)
                            .fontWeight(FontWeight.Light)
                            .fontSize(FontSize.Medium)

                    )


                }
            } else {
                Column(
                    verticalArrangement = Arrangement.Top,
                    horizontalAlignment = Alignment.Start,
                    modifier = Modifier
                        .fillMaxWidth(90.percent)
                        .padding(20.px)
                        .margin(top = 20.px)
                        .backgroundColor(Theme.LightDarkGray.rgb)
                        .borderRadius(10.px)

                ) {

                    Form(
                        attrs = Modifier
                            .fillMaxWidth()
                            .toAttrs {  }
                    ) {
                        MyTextField(
                            modifier = Modifier
                                .fillMaxWidth()
                                .height(50.px)
                                .padding(leftRight = 10.px)
                                .margin(bottom = 24.px)
                                .fontSize(16.px)
                                .borderRadius(10.px),
                            text = userName,
                            autoComplete = AutoComplete.email,
                            style = LoginStyle,
                            inputTypeHTML = InputTypeHTML.Text,
                            placeholder = "Correo electrónico",
                            onChange = { setUsername(it) },
                            onEnter = {
                                (document.getElementById(passwordTextFieldId) as HTMLInputElement).focus();
                            }

                        )

                        MyTextField(
                            id = passwordTextFieldId,
                            modifier = Modifier
                                .fillMaxWidth()
                                .height(50.px)
                                .padding(leftRight = 10.px)
                                .margin(bottom = 24.px)
                                .fontSize(16.px)
                                .borderRadius(10.px),
                            text = password,
                            autoComplete = AutoComplete.currentPassword,
                            style = LoginStyle,
                            inputTypeHTML = InputTypeHTML.Password,
                            placeholder = "Contraseña",
                            onChange = {
                                setPassword(it) },
                            onEnter = {
                                scope.logInUseCase(
                                    remember = (document.getElementById(IdConst.checkBoxRememberLogin) as HTMLInputElement).checked,
                                    asAdmin = false,
                                    userName = userName,
                                    password = password,
                                    setErrorText = { errorMessages ->
//                                console.log("errorMessages=$errorMessages")
                                        onLoginFail(errorMessages)
//                                setErrorText(errorMessages)

                                    },
                                    onLoginSuccess = { successMessage ->
                                        onLoginSuccess(successMessage)
                                    }
                                )
                            }
                        )
                    }


                    Row(
                        horizontalArrangement = Arrangement.SpaceBetween,
                        verticalAlignment = Alignment.CenterVertically,
                        modifier = Modifier
                            .fillMaxWidth()
                            .margin(bottom = 24.px)
                    ) {
                        MyCheckBox(
                            borderRadius = 5.px,
                            text = "Recordarme",
                            checked = getRememberedLogin(),
                            onClick = {},
                        )

                        MyButtonNew(
                            modifier = Modifier
                                .fillMaxHeight(),
                            style = ForgetPasswordButtonStyle,
                            id = forgotPasswordButtonId,
                            borderRadius = 5.px,
                            text = "¿Olvidaste tu contraseña?",
                            fontSize = 13,
                            onClick = {
                                showForgotPasswordDialog = true
                            }
                        )
                    }



                    MyButton(
                        id = loginButtonId,
                        text = "Iniciar Sesión",
                        buttonType = MyButtonType.Primary,
                        modifier = Modifier
                            .height(50.px)
                            .fillMaxWidth()
                            .margin(bottom = 24.px),
                        onClick = {
                            scope.logInUseCase(
                                remember = (document.getElementById(IdConst.checkBoxRememberLogin) as HTMLInputElement).checked,
                                asAdmin = false,
                                userName = userName,
                                password = password,
                                setErrorText = { errorMessages ->
//                                console.log("errorMessages=$errorMessages")
                                    onLoginFail(errorMessages)
//                                setErrorText(errorMessages)
                                },
                                onLoginSuccess = { successMessage ->
                                    onLoginSuccess(successMessage)
                                }
                            )
                        }

                    )


                    SpanText(
                        text = errorText,
                        modifier = Modifier
                            .fillMaxWidth()
                            .textAlign(TextAlign.Center)
                            .id(forgotPasswordText)
                            .color(Colors.Red)
                            .padding(leftRight = 24.px)
//                        .margin(bottom = 24.px)
                            .fontWeight(FontWeight.Light)
                            .fontSize(FontSize.Medium)

                    )

                }
            }




            MySpanText( //aun no tienes una cuenta
                text = "¿Aún no tenés cuenta? Registrate aqui completamente gratis y se parte de nuestra comunidad",
                fontColor = Theme.HalfBlack.rgb,
                fontSize = 15,
                modifier = Modifier
                    .fillMaxWidth(90.percent)
                    .textAlign(TextAlign.Center)
                    .margin(top = 20.px)
            )

            MyButtonNew(
                modifier = Modifier
                    .height(60.px)
                    .minHeight(60.px)
                    .width(90.percent)
                    .margin(bottom = 24.px, top = 12.px),
                style = RegisterButtonStyle,
                id = forgotPasswordButtonId,
                borderRadius = 15.px,
                text = "Registrarme",
                faIconsClassName = Resources.FaIconsClassName.Register_User_ICO,
                fontSize = 18,
                onClick = {
                    onSignUpButtonClick()
                }
            )


            FooterSectionDialog()





        }
    }
}